/** @jsxImportSource theme-ui */
import { Paragraph } from "theme-ui";

const Copyright = () => {
  return (
    <Paragraph sx={{ color: "themedCream" }}>
      &copy; {new Date().getFullYear()} Body Cam Review, LLC. All rights
      reserved.
    </Paragraph>
  );
};

export default Copyright;
